import type { ReactNode } from 'react'

/**
 * Une illustration par salle, reprise de l'ouverture de la Main Courante
 * (`swIllu`) : on reconnaît la salle à son nom (ROOM 1/2/3, ou les anciens
 * SALON, PLANÈTE, CLUB) ; toute autre reçoit le motif neutre. L'assistant
 * et l'onglet « La soirée » de la fiche dessinent les mêmes cartes de salles.
 */
export function illustrationSalle(nom: string): { classe: string; style: string; svg: ReactNode } {
  const n = nom.toUpperCase()
  const trace = { viewBox: '0 0 48 48', fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, 'aria-hidden': true } as const
  if (n.includes('ROOM 1') || n.includes('ROOM1') || n.includes('SALON')) {
    return { classe: 'bsw-salle--r1', style: 'Généraliste', svg: <svg {...trace}><circle cx="24" cy="18" r="9" /><path d="M15 18h18M24 9v18M17.6 11.6l12.8 12.8M30.4 11.6 17.6 24.4" /><path d="M12 40c2-6 6-9 12-9s10 3 12 9" /></svg> }
  }
  if (n.includes('ROOM 2') || n.includes('ROOM2') || n.includes('PLANETE') || n.includes('PLANÈTE')) {
    return { classe: 'bsw-salle--r2', style: 'RAP / RNB', svg: <svg {...trace}><circle cx="24" cy="24" r="13" /><ellipse cx="24" cy="24" rx="20" ry="6" transform="rotate(-22 24 24)" /><circle cx="24" cy="24" r="3" /></svg> }
  }
  if (n.includes('ROOM 3') || n.includes('ROOM3') || n.includes('CLUB')) {
    return { classe: 'bsw-salle--r3', style: 'Techno', svg: <svg {...trace}><rect x="8" y="10" width="32" height="28" rx="3" /><circle cx="18" cy="24" r="6" /><circle cx="33" cy="18" r="3" /><path d="M30 30h8" /></svg> }
  }
  return { classe: 'bsw-salle--autre', style: '', svg: <svg {...trace}><path d="M8 40V18l16-10 16 10v22z" /><path d="M18 40V28h12v12" /></svg> }
}
